module.exports = __webpack_public_path__ + "static/media/4.d5820b5f.png";